export const HORARIO_CORRIDO = 'CORRIDO';
export const CON_DESCANSO = 'CONDESCANSO';
export const NOCTURNO = 'NOCTURNO';
export const FRACCIONADO = 'FRACCIONADO';